module.exports = "/next-static/_next/static/images/setUpRecordingStudio-1b19b9d1ce1bde8a1a6783703f7be1a5.png";